var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M40 7.5c-7.249 0-13.125 5.876-13.125 13.125v6.25h-7.5v-6.25C19.375 9.235 28.609 0 40 0s20.625 9.234 20.625 20.625V43.75h-7.5V20.625C53.125 13.376 47.249 7.5 40 7.5",
    clipRule: "evenodd",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M56.875 41.875a3.75 3.75 0 0 0 3.75-3.75v-11.25H70a5 5 0 0 1 5 5v35.47c0 2.852-1.606 5.488-4.238 6.59C61.2 77.938 50.675 80.022 39.99 80h-1.193a82 82 0 0 1-11.618-.996A78 78 0 0 1 9.23 73.92C6.603 72.816 5 70.182 5 67.332V31.875a5 5 0 0 1 5-5h43.125v11.25a3.75 3.75 0 0 0 3.75 3.75M40 46.25A3.75 3.75 0 0 0 36.25 50v12.5a3.75 3.75 0 1 0 7.5 0V50A3.75 3.75 0 0 0 40 46.25",
    clipRule: "evenodd"
  })));
};
export default SvgLock;